require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-taller-reformas-globales-y-alcances-nacionales-en.json") })
        }
      }, "path---es-mx-update-taller-reformas-globales-y-alcances-nacionales-en");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-taller-reformas-globales-y-alcances-nacionales-en!./.cache/json/es-mx-update-taller-reformas-globales-y-alcances-nacionales-en.json
// module id = 936
// module chunks = 231608221292675